import { IHourlyWindModel } from "../interfaces";

export class HourlyWindModel implements IHourlyWindModel {
  windSpeed_850hPa: number;
  windDirection_850hPa: number;
  windDirection_900hPa: number;
  windSpeed_900hPa: number;
  windDirection_700hPa: number;
  windSpeed_700hPa: number;
  windDirection_925hPa: number;
  windSpeed_925hPa: number;
  hour: string;
  windDirectionName850hPa: string;
  windDirectionName900hPa: string;
  windDirectionName700hPa: string;
  windDirectionName925hPa: string;
  speedTextCss900: string;
  speedTextCss700: string;
  speedTextCss850: string;
  speedTextCss925: string;
  windGusts10m: number;
  gustsTextCss10m: string;



  constructor(data: IHourlyWindModel) {
    if (data) {
      this.windSpeed_850hPa = data.windSpeed_850hPa;
      this.windDirection_850hPa = data.windDirection_850hPa;
      this.windDirection_900hPa = data.windDirection_900hPa;
      this.windSpeed_900hPa = data.windSpeed_900hPa;
      this.hour = data.hour;
      this.windDirectionName850hPa = data.windDirectionName850hPa;
      this.windDirectionName900hPa = data.windDirectionName900hPa;
      this.speedTextCss900 = data.speedTextCss900;
      this.speedTextCss700 = data.speedTextCss700;
      this.speedTextCss850 = data.speedTextCss850;
      this.speedTextCss925 = data.speedTextCss925;
      this.windDirection_700hPa = data.windDirection_700hPa;
      this.windDirection_925hPa = data.windDirection_925hPa;
      this.windSpeed_925hPa = data.windSpeed_925hPa;
      this.windSpeed_700hPa = data.windSpeed_700hPa;
      this.windDirectionName700hPa = data.windDirectionName700hPa;
      this.windDirectionName925hPa = data.windDirectionName925hPa;
      this.windGusts10m = data.windGusts10m;
      this.gustsTextCss10m = data.gustsTextCss10m;
    }
  }
}
